import "./index.css";
import React from "react";
import { render } from "react-dom";
import { App } from "./App";
import { KrystleRothApp } from "./KrystleRothApp";
const path = window.location.pathname.replace(/\/+$/, "").toLowerCase();
const Root = path === "/krystleroth" ? KrystleRothApp : App;
render(<Root data-id="element-597" />, document.getElementById("root"));